import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=a5042400&scoped=true&"
var script = {}
import style0 from "./Footer.vue?vue&type=style&index=0&id=a5042400&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5042400",
  null
  
)

export default component.exports